import React, { useEffect } from 'react';
import { animated, useSprings } from 'react-spring';
import { casesList } from './config';
import cx from 'classnames';

export default function Screenshot(props: {
    selectIndex: number;
    setSelectIndex: (i: number) => any;
}) {
    const { selectIndex, setSelectIndex } = props;

    const afterList = casesList.slice(selectIndex).concat(casesList.slice(0, selectIndex));
    function springsFn(selectIndex: number) {
        return (index: number) => {
            const order = afterList.findIndex((item) => item.key === index);
            if (order === 3) {
                return {
                    transform: `translate3d(-200px,0px,0) scale(1.03)`,
                    zIndex: -1,
                    cursor: order > 0 ? 'pointer' : 'grab',
                    opacity: 0,
                };
            }
            return {
                transform: `translate3d(${order * 25}px,${order * 3}px,0) scale(${
                    1 - order * 0.05
                })`,
                zIndex: 10 - order,
                cursor: order > 0 ? 'pointer' : 'grab',
                opacity: order === 3 ? 0 : order > 0 ? 0.8 : 1,
            };
        };
    }
    const [springs, setTransition] = useSprings(casesList.length, springsFn(selectIndex));

    useEffect(() => {
        //@ts-expect-error
        setTransition(springsFn(selectIndex));
    }, [selectIndex]);

    return (
        <div className="screenshot">
            <div className="screenshot-wrapper">
                <ArrowSvg fill="#0961dc" />
                <ArrowSvg fill="#1bcbde" />
                {springs.map((props, index) => {
                    const order = afterList.findIndex((item) => item.key === index);
                    return (
                        <animated.div
                            key={index}
                            className="screenshot-sheet"
                            style={{
                                ...props,
                                zIndex: order === 3 ? 15 : 10 - order,
                            }}
                            onClick={() => setSelectIndex(index)}
                        >
                            <img
                                src={casesList[index].screenshot}
                                alt=""
                                style={{
                                    boxShadow: '2px 2px 16px 0 rgba(0,0,0,0.20)',
                                    borderRadius: 25,
                                }}
                            />
                        </animated.div>
                    );
                })}
                <div className="process-dot">
                    {casesList.map((item, index) => (
                        <span
                            onAnimationEnd={() => {
                                setSelectIndex((selectIndex + 1) % 4);
                            }}
                            onClick={() => {
                                setSelectIndex(index);
                            }}
                            key={item.key}
                            className={cx({
                                current: selectIndex === item.key,
                            })}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

function ArrowSvg(props: { fill: string }) {
    return (
        <svg
            className="arrow-svg"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6993"
            width="200"
            height="200"
        >
            <path
                fill={props.fill}
                d="M971.9 762.9c31.3-30.4 31.3-79.7 0-110.2L568.7 261c-31.3-30.4-82.1-30.4-113.4 0L52.1 652.7c-31.3 30.5-31.3 79.8 0 110.2 31.3 30.4 82.1 30.4 113.4 0L512 426.3l346.5 336.6c31.3 30.5 82.1 30.5 113.4 0z"
                p-id="6994"
            ></path>
        </svg>
    );
}
